/* eslint-disable @typescript-eslint/camelcase */

export const KeyRoles = {
  SUPERADMIN: 'superadmin',
  ADMIN: 'admin',
  OPERATOR: 'operator',
  CLIENT_OPERATOR: 'client_operator',
};

export default {
  superadmin: 'Super Admin Sky.One',
  admin: 'Admin Sky.One',
  operator: 'SkyOne Operator',
  client_operator: 'Client Operator',
};
